import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { ModalProvider } from '@leroy-merlin-br/backyard-react-ui'

import { baseStyles } from './styles'

const Container = styled('div')(baseStyles)

const App = ({ children }) => (
  <ModalProvider>
    <Container>{children}</Container>
  </ModalProvider>
)

App.propTypes = {
  children: PropTypes.node.isRequired
}

export default App
